var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { html, css, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { qboui } from './styles.js';
let QboPaginate = class QboPaginate extends LitElement {
    constructor() {
        super(...arguments);
        this.display = 25;
        this.start = 0;
        this.count = 0;
        this.pageLimit = 10;
        this.currentPage = 1;
        this.rollingView = true;
        this.editSize = true;
        this.displayCountText = 'Results per page:';
    }
    get maxPage() {
        return Math.floor(this.count / this.display) + (this.count % this.display === 0 ? 0 : 1);
    }
    static { this.styles = [
        qboui,
        css ``
    ]; }
    // Go to a specific page
    goToPage(page) {
        if (page < 1)
            page = 1;
        else if (page > this.maxPage)
            page = this.maxPage;
        this.currentPage = page;
        this.dispatchEvent(new CustomEvent('change', {
            detail: { start: (page - 1) * this.display, display: this.display, page: page },
            bubbles: true,
            composed: true,
        }));
    }
    renderPage(i) {
        return html `<li class="${this.currentPage === i ? 'active' : ''}">
          <a @click="${(e) => this.goToPage(i)}">${i}</a>
        </li>`;
    }
    renderSpacer() {
        return html `<li class="disabled"><a>...</a></li>`;
    }
    renderPageNumbers() {
        const pages = [];
        let first = (this.maxPage > this.pageLimit)
            ? this.currentPage - Math.floor(this.pageLimit / 2)
            : 1;
        if (first < 1)
            first = 1;
        if (first + this.pageLimit > this.maxPage)
            first = this.maxPage - this.pageLimit + 1;
        if (first < 1)
            first = 1;
        let last = (this.maxPage > this.pageLimit)
            ? first + this.pageLimit - 1
            : this.maxPage;
        if (last <= 1)
            last = 1;
        if (first > 1) {
            pages.push(this.renderPage(1));
            pages.push(this.renderSpacer());
        }
        for (let i = first; i <= last; i++) {
            pages.push(this.renderPage(i));
        }
        if (last < this.maxPage) {
            pages.push(this.renderSpacer());
            pages.push(this.renderPage(this.maxPage));
        }
        return pages;
    }
    setDisplaySize(e) {
        const target = e.target;
        const display = parseInt(target.value);
        if (!isNaN(display)) {
            this.display = display;
            this.start = 0;
            this.goToPage(1);
        }
    }
    renderPageSize() {
        return html `<li class="pageSize">
  <span>${this.displayCountText}</span>
  <input type="number" min="5" value="${this.display}" title="Display Size" @change=${(e) => this.setDisplaySize(e)}>
</li>`;
    }
    render() {
        return html `
      <nav aria-label="Page navigation">
        <ul class="qbo-paginate">
          <li class="${this.currentPage === 1 ? 'disabled' : ''}">
            <a aria-label="Previous" @click="${(e) => this.goToPage(this.currentPage - 1)}">
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>
          ${this.renderPageNumbers()}
          <li class="${this.currentPage === this.maxPage ? 'disabled' : ''}">
            <a aria-label="Next" @click="${(e) => this.goToPage(this.currentPage + 1)}">
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
          ${this.editSize ? this.renderPageSize() : html ``}
        </ul>
      </nav>`;
    }
};
__decorate([
    property({ type: Number }),
    __metadata("design:type", Object)
], QboPaginate.prototype, "display", void 0);
__decorate([
    property({ type: Number }),
    __metadata("design:type", Object)
], QboPaginate.prototype, "start", void 0);
__decorate([
    property({ type: Number }),
    __metadata("design:type", Object)
], QboPaginate.prototype, "count", void 0);
__decorate([
    property({ type: Number }),
    __metadata("design:type", Object)
], QboPaginate.prototype, "pageLimit", void 0);
__decorate([
    property({ type: Number }),
    __metadata("design:type", Object)
], QboPaginate.prototype, "currentPage", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboPaginate.prototype, "rollingView", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], QboPaginate.prototype, "editSize", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboPaginate.prototype, "displayCountText", void 0);
QboPaginate = __decorate([
    customElement('qbo-paginate')
], QboPaginate);
export { QboPaginate };
